import { render, staticRenderFns } from "./audioModal.vue?vue&type=template&id=60f27598&"
import script from "./audioModal.vue?vue&type=script&lang=ts&"
export * from "./audioModal.vue?vue&type=script&lang=ts&"
import style0 from "./audioModal.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports